var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-chat',{attrs:{"mode":"mcpResource","data":_vm.data,"res-id":_vm.resId}})
}
var staticRenderFns = []

export { render, staticRenderFns }